import { createSlice } from '@reduxjs/toolkit'

import { ANIMATION_PLAY_STATE, ANIMATION_CANVAS_STATE } from './types'
import { ANIMATION_IDENTIFIERS, DrawAnimationResult } from '@Animation/types'
import { GAME_SPEED } from '@AppState/app-settings'

type AnimationState = {
  animationIdentifier: ANIMATION_IDENTIFIERS
  canvasState: ANIMATION_CANVAS_STATE
  displayNumberIndex: number
  gameSpeed: GAME_SPEED
  hasReachedEndOfAnimation: boolean
  isPaused: boolean
  message: string
  playState: ANIMATION_PLAY_STATE
  result: DrawAnimationResult | null
  showAddonPanel: boolean
}

const initialState: AnimationState = {
  animationIdentifier: ANIMATION_IDENTIFIERS.DEFAULT,
  canvasState: ANIMATION_CANVAS_STATE.INIT,
  displayNumberIndex: 0,
  gameSpeed: GAME_SPEED.NORMAL,
  hasReachedEndOfAnimation: false,
  isPaused: false,
  message: '',
  playState: ANIMATION_PLAY_STATE.READY,
  result: null,
  showAddonPanel: false,
}

export const animationSlice = createSlice({
  name: 'animation',
  initialState,
  reducers: {
    resetAnimation(state) {
      state.displayNumberIndex = 0
      state.showAddonPanel = false
    },
    setAddOnPanelState(state, action) {
      state.showAddonPanel = action.payload
    },
    setCanvasState(state, action) {
      state.canvasState = action.payload
    },
    setPlayState(state, action) {
      // Handles logic for deciding whether we should be in a finished or pause state when reaching the end of the animation
      switch (action.payload) {
        case ANIMATION_PLAY_STATE.FINISHED:
          state.hasReachedEndOfAnimation = true
          state.playState =
            state.playState === ANIMATION_PLAY_STATE.PAUSED
              ? ANIMATION_PLAY_STATE.PAUSED
              : action.payload
          break
        case ANIMATION_PLAY_STATE.GAME_LOADING:
          state.hasReachedEndOfAnimation = false
          state.playState = action.payload
          break
        case ANIMATION_PLAY_STATE.PLAYING:
          state.playState = state.hasReachedEndOfAnimation
            ? ANIMATION_PLAY_STATE.FINISHED
            : action.payload
          break
        default:
          state.playState = action.payload
          break
      }
    },
    updateDisplayNumberIndex(state, action) {
      state.displayNumberIndex = action.payload
    },
    setPaused(state, action) {
      state.isPaused = action.payload
    },
    setGameSpeed(state, action) {
      state.gameSpeed = action.payload
    },
    playNewDraw(state, action) {
      state.animationIdentifier = action.payload.identifier
      state.result = action.payload.result
      state.displayNumberIndex = 0
      state.showAddonPanel = false
      state.playState = ANIMATION_PLAY_STATE.GAME_LOADING
    },
    clearDrawResult(state) {
      state.result = null
      state.playState = ANIMATION_PLAY_STATE.READY
    },
    crash(state, action) {
      state.playState = ANIMATION_PLAY_STATE.CRASHED
      state.message = action.payload
    },
  },
})

export const AnimationActions = {
  ...animationSlice.actions,
}

export const AnimationReducer = animationSlice.reducer
